import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditPassword = mutatorAction('updateEditPassword', function (password) {
    var store = connectedAccountsStore();
    store.editAccountState.password = password;
});
//# sourceMappingURL=updateEditPassword.js.map